import { Controller } from "stimulus"
import Swal from "sweetalert2";

export default class extends Controller {
  static targets = [ 'emptyMessage', 'container' ];
  static values = { listSize: Number };

  connect() {
    this.updateEmptyMessage();
    this.element.querySelector('a.add-row').addEventListener('add-row:appended', () => this.listSizeValue += 1);
  }

  removeCategory(ev) {
    let $row = ev.currentTarget.closest('.row'),
      inputName = $row.dataset.inputName;
    this.askConfirmation().then((result) => {
      if (result.value) {
        this.containerTarget.insertAdjacentHTML('beforeend', `<input type="hidden" name="${inputName}[_destroy]" value="1" />`);
        $row.remove();
        this.listSizeValue -= 1;
        return;
      }
    });
  }

  askConfirmation() {
    return Swal.fire({
      customClass: {
        cancelButton: 'btn btn-gray-primary mx-2',
        confirmButton: 'btn btn-danger mx-2'
      },
      buttonsStyling: false,
      title: 'Atenção',
      text: "Tem certeza que deseja remover essa parte?",
      type: 'warning',
      animation: false,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, tenho certeza'
    });
  }

  listSizeValueChanged() {
    this.updateEmptyMessage();
  }

  updateEmptyMessage() {
    this.emptyMessageTarget.classList.toggle('hidden', this.listSizeValue > 0);
    this.containerTarget.classList.toggle('hidden', this.listSizeValue == 0);
  }
}